export default __webpack_public_path__ + "static/media/PINCH HAZARD SIMULATOR.6c748557.JPG";